import React, { useState } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AdminPageShell, { AdminSurface } from "../../components/Admin/AdminPageShell";
import { getApiUrl } from "../../utils/site";

export default function SendCampaign() {
  const [subject, setSubject] = useState("");
  const [html, setHtml] = useState("");
  const [status, setStatus] = useState("");

  const handleSend = async (e) => {
    e.preventDefault();
    setStatus("Sending campaign...");
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        getApiUrl("/api/email/campaign"),
        { subject, html },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStatus("Campaign sent successfully.");
    } catch (err) {
      setStatus(err.response?.data?.error || "Failed to send campaign.");
    }
  };

  return (
    <AdminPageShell
      eyebrow="Campaign studio"
      title="Send Campaign"
      description="Compose premium email campaigns with a cleaner editor, clearer preview, and better delivery workflow."
    >
      <div className="roha-admin-split">
        <AdminSurface title="Campaign editor" subtitle="Create the message that will go to your subscriber base">
          <form className="roha-admin-form-grid" onSubmit={handleSend}>
            <div className="roha-admin-field">
              <label>Subject line</label>
              <input
                type="text"
                className="form-control"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>

            <div className="roha-admin-field">
              <label>HTML content</label>
              <ReactQuill theme="snow" value={html} onChange={setHtml} style={{ minHeight: 220 }} />
            </div>

            <div className="roha-admin-toolbar">
              <button className="roha-admin-navbar__chip roha-admin-navbar__chip--primary" type="submit">
                Send campaign
              </button>
              {status ? <span className="roha-admin-pill">{status}</span> : null}
            </div>
          </form>
        </AdminSurface>

        <AdminSurface title="Live preview" subtitle="Review how the message feels before sending">
          <div
            style={{
              border: "1px solid rgba(20, 51, 47, 0.08)",
              borderRadius: 20,
              padding: 18,
              background: "#fff",
              minHeight: 260,
            }}
            dangerouslySetInnerHTML={{ __html: html || "<p class='roha-admin-muted'>Campaign preview will appear here.</p>" }}
          />
        </AdminSurface>
      </div>
    </AdminPageShell>
  );
}
